import styled from "styled-components";
import { BRAND_DARKEST, WHITE } from "@streeteasy/design-system/colors";
import TextLink, {
  textLinkTypography
} from "@streeteasy/design-system/deprecated/actions/text-link";
import { SecondarySmall } from "@streeteasy/design-system/typography";

export const FairHousingBannerContainer = styled.section`
  background: ${BRAND_DARKEST};
  padding: 12px 24px;
  text-align: center;
`;

export const FairHousingBannerCopy = styled(SecondarySmall).attrs({ as: "p" })`
  color: ${WHITE};
`;

export const FairHousingBannerLink = styled(TextLink).attrs({
  color: WHITE,
  typography: textLinkTypography.SECONDARY_SM
})``;
